import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import JsonLd from "@/components/JsonLd";

export default function Breadcrumbs({ items }) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `https://taxipark.ge${it.path}`,
    })),
  };
  return (
    <nav aria-label="breadcrumb" className="mb-8" data-testid="breadcrumbs">
      <JsonLd data={schema} />
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-gray-500">
        {items.map((it, i) => (
          <li key={it.path} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-gray-600" />}
            {i < items.length - 1 ? (
              <Link to={it.path} className="hover:text-[#E5C378] transition-colors">{it.name}</Link>
            ) : (
              <span className="text-gray-300" aria-current="page">{it.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
